import { useState, useEffect } from "react";
import { useLocation } from "wouter";
import { LoginModal } from "@/components/LoginModal";

import { Footer } from "@/components/Footer";
import { useAuth } from "@/lib/authContext";
import { useI18n } from "@/lib/i18n";

export default function LoginPage() {
  const [, setLocation] = useLocation();
  const { isLoggedIn } = useAuth();
  const { t } = useI18n();
  const [loginModalOpen, setLoginModalOpen] = useState(true);
  const searchParams = new URLSearchParams(window.location.search);
  const initialSignUp = searchParams.get("signup") === "true";

  // Redirect to account if already logged in
  useEffect(() => {
    if (isLoggedIn) {
      setLocation("/account");
    }
  }, [isLoggedIn, setLocation]);

  return (
    <div className="min-h-screen flex flex-col bg-background">


      <main className="flex-1 container mx-auto px-4 py-16 flex items-center justify-center">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold mb-2">{t("login.welcomeBack")}</h1>
            <p className="text-muted-foreground">
              {t("login.subtitle")}
            </p>
          </div>

          <LoginModal
            open={loginModalOpen}
            onOpenChange={(open) => {
              setLoginModalOpen(open);
              if (!open) {
                // If modal is closed and user is still not logged in, go back
                if (!isLoggedIn) {
                  setLocation("/");
                }
              }
            }}
            action="default"
            initialSignUp={initialSignUp}
          />
        </div>
      </main>

      <Footer />
    </div>
  );
}
